"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionsSchema = void 0;
const zod_1 = require("zod");
const question_schema_1 = require("./question.schema");
exports.questionsSchema = zod_1.z.array(question_schema_1.questionSchema).min(1).describe("List of one or more questions");
